/**
 * Truncates a filename in the middle, preserving the start and the extension.
 * e.g., "0bcc96e6-9890-4e88-8abc-1234567890ab.png" → "0bcc96e6…67890ab.png"
 */
export function truncateMiddle(name: string, maxLength = 20): string {
  if (name.length <= maxLength) return name;

  const extIndex = name.lastIndexOf(".");
  const ext = extIndex > 0 ? name.slice(extIndex) : "";
  const nameWithoutExt = extIndex > 0 ? name.slice(0, extIndex) : name;

  const charsToShow = maxLength - ext.length - 1; // 1 for "…"
  if (charsToShow <= 0) return name.slice(0, maxLength - 1) + "…";

  const frontChars = Math.ceil(charsToShow / 2);
  const backChars = Math.floor(charsToShow / 2);

  return (
    nameWithoutExt.slice(0, frontChars) +
    "…" +
    (backChars > 0 ? nameWithoutExt.slice(-backChars) : "") +
    ext
  );
}
